export interface PriceAdjustmentSuggestion {
  minimumVolume?: number;
  maximumVolume?: number;
  priceAdjustmentPercent: number;
}

export const fetchFormPriceAdjustmentSuggestions = () : Promise<PriceAdjustmentSuggestion[]> => Promise.resolve([
  { maximumVolume: 0.003, priceAdjustmentPercent: 50 },
  { minimumVolume: 0.003, maximumVolume: 0.007, priceAdjustmentPercent: 40 },
  { minimumVolume: 0.007, maximumVolume: 0.010, priceAdjustmentPercent: 30 },
  { minimumVolume: 0.010, maximumVolume: 0.025, priceAdjustmentPercent: 20 },
  { minimumVolume: 0.025, maximumVolume: 0.040, priceAdjustmentPercent: 10 },
  { minimumVolume: 0.040, priceAdjustmentPercent: 5 },
]);

export const fetchShapePriceAdjustmentSuggestions = () : Promise<PriceAdjustmentSuggestion[]> => Promise.resolve([
  { maximumVolume: 0.05, priceAdjustmentPercent: 30 },
  { minimumVolume: 0.05, maximumVolume: 0.10, priceAdjustmentPercent: 20 },
  { minimumVolume: 0.10, priceAdjustmentPercent: 15 },
]);